import "core-js/modules/es6.object.create";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React from 'react';
import Layout from '../components/layout';
import '../styles/main.scss';

var Index =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Index, _React$Component);

  function Index() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Index.prototype;

  _proto.render = function render() {
    var html = this.props.data.allMarkdownRemark.edges[0].node.html;
    return React.createElement(Layout, {
      tabIndex: 0,
      selectedNavItemId: ''
    }, React.createElement("div", {
      className: "content-markdown",
      dangerouslySetInnerHTML: {
        __html: html
      }
    }));
  };

  return Index;
}(React.Component);

export default Index;
export var query = "1911517945";